export default __webpack_public_path__ + "static/091-f1ea89f7570365a6de15a01d1cf0079a.jpg";